import { FC } from 'react';
import theme from './RoomLabel.module.scss';

interface RoomLabelProps {
    name: string;
    labelNote?: string | null;
    className?: string;
}

const RoomLabel: FC<RoomLabelProps> = ({ name, labelNote, className }) => {
    const trimmedNote = labelNote?.trim();
    return (
        <span className={[theme.root, className].filter(Boolean).join(' ')}>
            {name}
            {trimmedNote && <span className={theme.note}>({trimmedNote})</span>}
        </span>
    );
};

export default RoomLabel;
